import { Skeleton, Typography } from '@mui/joy';
import { ContentWSectionHeading, ScrollSection } from '.';

export interface MethodologySectionProps {
	isFetching?: boolean;
	name?: string;
	heading?: string;
	htmlText: string;
}
export const MethodologySection = ({
	name = 'methodology',
	isFetching,
	heading = 'Methodology',
	htmlText
}: MethodologySectionProps) => {
	return (
		<ScrollSection name={name}>
			<ContentWSectionHeading heading={heading}>
				<Typography level='body1'>
					<Skeleton loading={isFetching ? isFetching : false}>
						<div
							dangerouslySetInnerHTML={{
								__html: htmlText
							}}
						/>
					</Skeleton>
				</Typography>
			</ContentWSectionHeading>
		</ScrollSection>
	);
};
